/**************************************************
 * Nombre:       Tarjeta_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Indicadores = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#F7F3FE',
                px: 2,
                py: 1
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{color: '#5B5470', fontSize: 14, fontWeight: 300}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{color: '#9049F5', fontSize: sCell ? 24 : 32, fontWeight: 600, lineHeight: 1.1}}>
                    {item.numero}
                </Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                <Typography sx={{
                    color: '#7A1CFF',
                    fontSize: 11,
                    fontWeight: 300,
                    border: 1,
                    borderColor: '#7A1CFF80',
                    px: 1,
                    borderRadius: 8,
                    lineHeight: 1,
                    py: 0.2
                }}>
                    {item.descripcion}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Indicadores